import { createHigherOrderComponent } from "@wordpress/compose";
import { InspectorControls } from "@wordpress/block-editor";
import { PanelBody } from "@wordpress/components";
import React from "react";
import ResponsiveRange from "../components/ResponsiveRange";

const withDimensionsControls = createHigherOrderComponent(
    (WrappedComponent) => {
        return function DimensionsControlsWrapper(props) {
            const { attributes, setAttributes, name, clientId } = props;

            if (!["core/group", "core/cover", "core/image"].includes(name)) {
                return <WrappedComponent {...props} />;
            }

            const handleUpdate = (
                name,
                device,
                direction,
                value,
                unit,
                shouldSave
            ) => {
                const attributeName = `${name}${
                    device.charAt(0).toUpperCase() + device.slice(1)
                }`;
                const newValue = {
                    ...attributes[attributeName],
                    value: value,
                    valueUnit: unit,
                };
                setAttributes({ [attributeName]: newValue });
            };

            const handleReset = (name, device) => {
                const attributeName = `${name}${
                    device.charAt(0).toUpperCase() + device.slice(1)
                }`;
                setAttributes({ [attributeName]: {} });
            };

            // Dodaj style edytora
            const editorStyles = `
                #block-${clientId} {
                    ${
                        attributes.widthDesktop?.value
                            ? `width: ${attributes.widthDesktop.value}${
                                  attributes.widthDesktop.valueUnit || "px"
                              } !important;`
                            : ""
                    }
                    ${
                        attributes.heightDesktop?.value
                            ? `height: ${attributes.heightDesktop.value}${
                                  attributes.heightDesktop.valueUnit || "px"
                              } !important;`
                            : ""
                    }

                    @media (max-width: 1024px) {
                        ${
                            attributes.widthTablet?.value
                                ? `width: ${attributes.widthTablet.value}${
                                      attributes.widthTablet.valueUnit || "px"
                                  } !important;`
                                : ""
                        }
                        ${
                            attributes.heightTablet?.value
                                ? `height: ${attributes.heightTablet.value}${
                                      attributes.heightTablet.valueUnit || "px"
                                  } !important;`
                                : ""
                        }
                    }

                    @media (max-width: 767px) {
                        ${
                            attributes.widthMobile?.value
                                ? `width: ${attributes.widthMobile.value}${
                                      attributes.widthMobile.valueUnit || "px"
                                  } !important;`
                                : ""
                        }
                        ${
                            attributes.heightMobile?.value
                                ? `height: ${attributes.heightMobile.value}${
                                      attributes.heightMobile.valueUnit || "px"
                                  } !important;`
                                : ""
                        }
                    }
                }
            `;

            return (
                <>
                    <style>{editorStyles}</style>
                    <WrappedComponent {...props} />
                    <InspectorControls>
                        <PanelBody title="Wymiary" initialOpen={false}>
                            <ResponsiveRange
                                type="single"
                                name="width"
                                tabLabel="Width"
                                attributes={attributes}
                                updateValue={handleUpdate}
                                onReset={handleReset}
                                max={1000}
                            />
                            <ResponsiveRange
                                type="single"
                                name="height"
                                tabLabel="Height"
                                attributes={attributes}
                                updateValue={handleUpdate}
                                onReset={handleReset}
                                max={1000}
                            />
                        </PanelBody>
                    </InspectorControls>
                </>
            );
        };
    },
    "withDimensionsControls"
);

export default withDimensionsControls;
